import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_select_form = _resolveComponent("select-form");
    const _component_el_col = _resolveComponent("el-col");
    const _component_el_row = _resolveComponent("el-row");
    const _component_el_tag = _resolveComponent("el-tag");
    const _component_el_card = _resolveComponent("el-card");
    const _directive_loading = _resolveDirective("loading");
    return (_openBlock(), _createElementBlock("div", null, [
        (!_ctx.preview)
            ? (_openBlock(), _createBlock(_component_el_row, {
                key: 0,
                gutter: 24,
                class: "mb-4"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_el_col, { lg: 12 }, {
                        default: _withCtx(() => [
                            _createVNode(_component_select_form, {
                                label: "Scheme",
                                modelValue: _ctx.modelSchema.schemeId,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.modelSchema.schemeId) = $event)),
                                desctiption: "Masukkan schema code",
                                options: _ctx.schemaOptions,
                                disabled: "",
                                onChange: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('selectSchema', $event)))
                            }, null, 8 /* PROPS */, ["modelValue", "options"])
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_component_el_col, { lg: 12 }),
                    _createVNode(_component_el_col, { lg: 12 }, {
                        default: _withCtx(() => [
                            _createVNode(_component_select_form, {
                                label: "Form Type",
                                modelValue: _ctx.modelSchema.answerTypeId,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.modelSchema.answerTypeId) = $event)),
                                desctiption: "Enter answer type",
                                options: _ctx.answerTypeOptions,
                                prop: `fields.${_ctx.order}.scheme.answerTypeId`,
                                rules: [_ctx.validationRequired()],
                                onChange: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('selectAnswerType', $event)))
                            }, null, 8 /* PROPS */, ["modelValue", "options", "prop", "rules"])
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }))
            : _createCommentVNode("v-if", true),
        _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
                _createVNode(_component_el_col, {
                    lg: 7,
                    class: "mb-4"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_el_card, {
                            header: "Unit Competency",
                            shadow: "never",
                            class: "primary-card"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("ol", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.competencyUnitList, (item, index) => {
                                        var _a;
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: index,
                                            class: "mb-4"
                                        }, [
                                            _createElementVNode("p", {
                                                class: _normalizeClass(item.id === _ctx.activedCompetencyUnitId ? 'text-primary' : ''),
                                                style: { "cursor": "pointer" },
                                                onClick: ($event) => (_ctx.activedCompetencyUnitId = item.id)
                                            }, _toDisplayString(item.title), 11 /* TEXT, CLASS, PROPS */, _hoisted_1),
                                            ((_a = _ctx.completedList.find((prev) => prev.id === item.id)) === null || _a === void 0 ? void 0 : _a.completed)
                                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                                    key: 0,
                                                    type: "success",
                                                    size: "small"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(" Completed ")
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }))
                                                : _createCommentVNode("v-if", true)
                                        ]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_component_el_col, { lg: 17 }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.competencyUnitList, (myCompetencyUnit, index) => {
                            var _a, _b, _c;
                            return _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent((_b = (_a = _ctx.answerTypeOptions
                                .find((item) => item.value === _ctx.modelSchema.answerTypeId)) === null || _a === void 0 ? void 0 : _a.label) === null || _b === void 0 ? void 0 : _b.replace(/[.]/gm, '')), {
                                key: index,
                                "competency-unit": myCompetencyUnit.competencyUnit,
                                scheme: _ctx.scheme,
                                "statement-fields": _ctx.statementFields,
                                relevantEvidenceFields: (_c = _ctx.relevantEvidenceFields) === null || _c === void 0 ? void 0 : _c.filter((item) => item.competencyUnitId === myCompetencyUnit.competencyUnit.id),
                                "answer-type-id": _ctx.modelSchema.answerTypeId,
                                disabled: _ctx.disabled,
                                isAssessment: _ctx.isAssessment,
                                order: _ctx.order,
                                competencyUnitFields: _ctx.competencyUnitFields,
                                onTriggerCompleted: ($event) => (_ctx.setCompleted($event, myCompetencyUnit.id))
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, ["competency-unit", "scheme", "statement-fields", "relevantEvidenceFields", "answer-type-id", "disabled", "isAssessment", "order", "competencyUnitFields", "onTriggerCompleted"])), [
                                [_vShow,
                                    myCompetencyUnit.competencyUnit &&
                                        myCompetencyUnit.competencyUnit.id === _ctx.activedCompetencyUnitId
                                ],
                                [_directive_loading, _ctx.competencyUnitOptions.loading]
                            ]);
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                })
            ]),
            _: 1 /* STABLE */
        })
    ]));
}
